import BASEAPI from '@/api/dataBase.js';
import { isNumberValidator } from '@/validators';
import { COMPANY_CODE1 } from '@/constants';

export const baseFormColum = (ctx) => {
  return [
    {
      prop: 'companyCode',
      name: '公司',
      type: 'select',
      label: 'personCompanyName',
      value: 'personCompanyCode',
      options: ctx.companyList || [],
      changeMethod: 'changeMethod',
      disabled: ctx.disabledFieldList.includes('companyCode'),
    },
    {
      prop: 'departmentCode',
      name: '业务部门',
      type: 'select',
      label: 'label',
      value: 'value',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
      disabled:
        ctx.baseFormData.companyCode == '' || ctx.disabledFieldList.includes('departmentCode'),
    },
    {
      prop: 'projectInitiationNo',
      name: '项目编号',
      searchType: 'projectInitiation',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseFormData?.projectInitiationNo
        ? ctx.baseFormData?.projectInitiationNo
        : null,
      checkRowKeys: [
        ctx.baseFormData.projectInitiationNo ? ctx.baseFormData.projectInitiationNo : null,
      ],
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        // applyCompanyNo: ctx.baseFormData.companyCode,
        // applyDepartmentNo: ctx.baseFormData.departmentCode,
        // platformtCompany: ctx.baseFormData.companyCode,
        // recyclingtCompany: ctx.baseFormData.companyCode,
        // applyDepartmentName: ctx.baseFormData.departmentName,

        // applyCompanyName: ctx.baseFormData.companyName,
        // platformtCompanyName: ctx.baseFormData.companyName,
        // recyclingtCompanyName: ctx.baseFormData.companyName,
      },
      changeMethod: 'changeMethod',
      disabled: ctx.disabledFieldList.includes('projectInitiationNo'),
    },
    {
      prop: 'projectName',
      name: '项目简称',
      type: 'input',
      disabled: true,
      placeholder: '自动带出项目简称',
    },
    {
      prop: 'contractName',
      name: '合同名称',
      type: 'input',
      placeholder: '请输入合同名称',
      disabled: ctx.disabledFieldList.includes('contractName'),
    },

    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB02,HZHB03,HZHB09,HZHB11,HZHB13',
        departmentCode: ctx.baseFormData.departmentCode, //部门
        companyCode: ctx.baseFormData.companyCode, //公司
      },
      currentValue: ctx.baseFormData.supplierName ? ctx.baseFormData.supplierName : null,
      checkRowKeys: [ctx.baseFormData.supplierNo ? ctx.baseFormData.supplierNo : null],
      isMultiple: true,
      changeMethod: 'changeMethod',
      isHidden: ctx.hiddenList.includes('supplierNo'),
      disabled: ctx.disabledFieldList.includes('supplierNo'),
    },
    //合同编号3
    {
      prop: 'contractNo',
      name: '合同编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
      isHidden: ctx.hiddenList.includes('contractNo'),
    },
    {
      prop: 'contractTotalAmount',
      name: '合同总金额',
      type: 'inputNumber',
      precision: 2,
      // disabled: true,
      placeholder: '自动生成',
      isHidden: ctx.hiddenList.includes('contractTotalAmount'),
    },
    {
      prop: 'purchaseQuantity',
      name: '采购数量',
      type: 'inputNumber',
      precision: 6,
      disabled: true,
      placeholder: '自动填充',
      isHidden: ctx.hiddenList.includes('purchaseQuantity'),
    },
    {
      prop: 'signDate',
      name: '合同签署日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      isHidden: ctx.hiddenList.includes('signDate'),
      disabled: ctx.disabledFieldList.includes('signDate'),
    },

    {
      prop: 'externalContractNo',
      name: '外部合同号',
      type: 'input',
      placeholder: '请输入外部合同号',
      isHidden: ctx.hiddenList.includes('externalContractNo'),
      disabled: ctx.disabledFieldList.includes('externalContractNo'),
    },
    {
      prop: 'contractSalesmanNo',
      name: '业务员',
      placeholder: '请选择业务员',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      extraData: {
        personCompanyCode: ctx.userInfo.companyCode,
      },
      changeMethod: 'changeMethod',
      currentValue: ctx.baseFormData?.contractSalesmanName,
      isHidden: ctx.hiddenList.includes('contractSalesmanNo'),
      disabled: ctx.disabledFieldList.includes('contractSalesmanNo'),
    },
    {
      prop: 'isDefault',
      name: '有无违约标识',
      type: 'checkbox',
      labelPosition: 'right',
      isHidden: ctx.hiddenList.includes('isDefault'),
      disabled: ctx.disabledFieldList.includes('isDefault'),
    },
    {
      prop: 'contractCreateDate',
      name: '制单日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: true,
      isHidden: ctx.hiddenList.includes('contractCreateDate'),
    },
    {
      prop: 'replyInvoiceDate',
      name: '回票日期',
      type: 'date',
      isHidden: ctx.hiddenList.includes('replyInvoiceDate'),
      disabled: ctx.disabledFieldList.includes('replyInvoiceDate'),
    },
    {
      name: '货币',
      prop: 'companyCurrency',
      type: 'ajaxSelect',
      apiUrl: BASEAPI.LIST_CURRENCY,
      clearable: true,
      filterable: true,
      apiData: { isEnabled: 1 },
      valueKey: 'currencyCode',
      labelKey: 'currencyName',
      changeMethod: 'changeMethod',
      method: 'get',
      valueType: 'object',
      isHidden: ctx.hiddenList.includes('companyCurrency'),
      disabled: ctx.disabledFieldList.includes('companyCurrency'),
    },
    {
      prop: 'liquidatedDamagesType',
      name: '合同违约金类型',
      type: 'input',
      placeholder: '请输入合同违约金类型',
      isHidden: ctx.hiddenList.includes('liquidatedDamagesType'),
      disabled: ctx.disabledFieldList.includes('liquidatedDamagesType'),
    },
    {
      prop: 'liquidatedFixedValue',
      name: '违约金固定值',
      type: 'input',
      placeholder: '请输入违约金固定值',
      isHidden: ctx.hiddenList.includes('liquidatedFixedValue'),
      disabled: ctx.disabledFieldList.includes('liquidatedFixedValue'),
    },
    {
      prop: 'liquidatedInterestRate',
      name: '违约金日利率',
      type: 'inputNumber',
      placeholder: '请输入违约金日利率',
      append: '%',
      isHidden: ctx.hiddenList.includes('liquidatedInterestRate'),
      disabled: ctx.disabledFieldList.includes('liquidatedInterestRate'),
    },
    {
      prop: 'creditPercent',
      name: '付款比例',
      type: 'inputNumber',
      placeholder: '请输入付款比例',
      append: '%',
      isHidden: ctx.hiddenList.includes('creditPercent'),
      disabled: ctx.disabledFieldList.includes('creditPercent'),
    },
    {
      prop: 'contractOperaterName',
      name: '操作人',
      type: 'input',
      disabled: true,
      isHidden: ctx.hiddenList.includes('contractOperaterName'),
    },
    {
      prop: 'lastestPayMoneyDay',
      name: '最晚付款日',
      type: 'date',
      format: 'yyyy-MM-dd',
      placeholder: '请选择最晚付款日',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 1 * 24 * 60 * 60 * 1000; //
        },
      },
      isHidden: ctx.hiddenList.includes('lastestPayMoneyDay'),
      disabled: ctx.disabledFieldList.includes('lastestPayMoneyDay'),
    },
    {
      prop: 'lastestReceiveProductDay',
      name: '最晚收货日',
      type: 'date',
      format: 'yyyy-MM-dd',
      placeholder: '请选择最晚收货日',
      isHidden: ctx.hiddenList.includes('lastestReceiveProductDay'),
      disabled: ctx.disabledFieldList.includes('lastestReceiveProductDay'),
    },
    {
      prop: 'businessType',
      name: '业务性质',
      type: 'select',
      options: ctx.dictListMap?.purchase_business_type || [],
      isHidden: ctx.hiddenList.includes('businessType'),
      disabled: ctx.disabledFieldList.includes('businessType'),
    },
    {
      prop: 'isPrepay',
      name: '预付',
      type: 'checkbox',
      labelPosition: 'right',
      changeMethod: 'changeMethod',
      isHidden: ctx.hiddenList.includes('isPrepay'),
      disabled: ctx.disabledFieldList.includes('isPrepay'),
    },
    {
      prop: 'creditAmount',
      name: '预付金额',
      type: 'input',
      disabled:
        (ctx.baseFormData.isPrepay ? false : true) ||
        ctx.disabledFieldList.includes('creditAmount'),
      placeholder: '请输入预付金额',
      isHidden: ctx.hiddenList.includes('creditAmount'),
    },
    {
      prop: 'isFixedPrice',
      name: '不定价',
      type: 'checkbox',
      labelPosition: 'right',
      disabled: true,
      isHidden: ctx.hiddenList.includes('isFixedPrice'),
    },
    {
      prop: 'receiptMethod',
      name: '付款方式',
      type: 'select',
      options: ctx.dictListMap?.apply_payment_method || [],
      changeMethod: 'changeMethod',
      isHidden: ctx.hiddenList.includes('receiptMethod'),
      disabled: ctx.disabledFieldList.includes('receiptMethod'),
    },
    {
      prop: 'contractValidStart',
      name: '合同生效日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      changeMethod: 'changeMethod',
      isHidden: ctx.hiddenList.includes('contractValidStart'),
      disabled: ctx.disabledFieldList.includes('contractValidStart'),
    },
    {
      prop: 'contractValidEnd',
      name: '合同到期日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      changeMethod: 'changeMethod',
      isHidden: ctx.hiddenList.includes('contractValidEnd'),
      disabled: ctx.disabledFieldList.includes('contractValidEnd'),
    },
    {
      prop: 'identityNo',
      name: '身份证号码',
      type: 'input',
      disabled: true,
      isHidden: ctx.hiddenList.includes('identityNo'),
    },
    {
      prop: 'bankAccount',
      name: '银行卡号',
      type: 'select',
      label: 'label',
      value: 'value',
      options: ctx.bankList || [],
      changeMethod: 'changeMethod',
      isHidden: ctx.hiddenList.includes('bankAccount'),
      disabled: ctx.disabledFieldList.includes('bankAccount'),
    },
    {
      prop: 'performanceBondPayMethodCode',
      name: '履约保证金缴纳方式',
      type: 'select',
      options: ctx.dictListMap?.performance || [],
      isHidden: ctx.hiddenList.includes('performanceBondPayMethodCode'),
      disabled: ctx.disabledFieldList.includes('performanceBondPayMethodCode'),
    },
    {
      prop: 'performanceBond',
      name: '履约保证金',
      type: 'input',
      placeholder: '请输入履约保证金',
      isHidden: ctx.hiddenList.includes('performanceBond'),
      disabled: ctx.disabledFieldList.includes('performanceBond'),
    },
    {
      prop: 'warrantyClause',
      name: '保供条款',
      type: 'input',
      placeholder: '请输入保供条款',
      isHidden: ctx.hiddenList.includes('warrantyClause'),
      disabled: ctx.disabledFieldList.includes('warrantyClause'),
    },
    {
      prop: 'overShippedPercentage',
      name: '溢装比例',
      type: 'inputNumber',
      append: '%',
      isHidden: ctx.hiddenList.includes('overShippedPercentage'),
      disabled: ctx.disabledFieldList.includes('overShippedPercentage'),
    },
    {
      prop: 'shortShippedPercentage',
      name: '短装比例',
      type: 'inputNumber',
      append: '%',
      isHidden: ctx.hiddenList.includes('shortShippedPercentage'),
      disabled: ctx.disabledFieldList.includes('shortShippedPercentage'),
    },
    {
      prop: 'isRestrict',
      name: '是否定量',
      type: 'select',
      options: [
        {
          value: '0',
          label: '否',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      isHidden: ctx.hiddenList.includes('isRestrict') || ctx.fileType == 'agreement',
      disabled: ctx.disabledFieldList.includes('isRestrict') || ctx.disabledIsRestrict,
    },
    // 19是否生成销售协议
    {
      prop: 'isGenerateSales',
      type: 'checkbox',
      labelPosition: 'right',
      width: '50',
      name: ctx.fileType == 'contract' ? '是否生成销售合同' : '是否生成销售协议',
      changeMethod: 'changeMethod',
      disabled: ctx.isDisabledGenerateSales || ctx.disabledFieldList.includes('isGenerateSales'),
      isHidden: ctx.hiddenList.includes('isGenerateSales'),
    },
    // {
    //   prop: 'customerName',
    //   name: '客户名称',
    //   type: 'searchTableSpec',
    //   searchType: 'partner',
    //   placeholder: '请输入客户名称',
    //   isMultiple: true,
    //   currentValue: ctx.baseFormData.customerName,
    //   extraData: {
    //     companyCode: ctx.baseFormData.generateSalesCompanyNo || ctx.userInfo.companyCode,
    //     departmentCode: ctx.baseFormData.generateSalesDepartment || ctx.userInfo.departmentCode,
    //     partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
    //     ...(ctx.baseFormData.isRelatedParty == 'Y' ? { isRelatedParty: 'Y' } : {}),
    //   },
    //   changeMethod: 'changeMethod',
    //   isHidden: ctx.hiddenList.includes('customerName'),
    //   disabled: ctx.disabledFieldList.includes('customerName'),
    // },
    {
      prop: 'generateNo',
      name: '关联销售合同号',
      type: 'input',
      disabled: true,
      placeholder: '请输入关联销售合同号',
      isHidden: ctx.hiddenList.includes('generateNo'),
    },
    // {
    //   prop: 'generateSalesCompanyName',
    //   name: '关联销售合同的业务公司',
    //   type: 'select',
    //   options: ctx.companyList2 || [],
    //   changeMethod: 'changeMethod',
    //   isHidden: ctx.hiddenList.includes('generateSalesCompanyName'),
    //   disabled: ctx.disabledFieldList.includes('generateSalesCompanyName'),
    // },
    // {
    //   prop: 'generateSalesDepartmentName',
    //   name: '关联销售合同的业务部门',
    //   type: 'select',
    //   options: ctx.departmentList2 || [],
    //   changeMethod: 'changeMethod',
    //   isHidden: ctx.hiddenList.includes('generateSalesDepartmentName'),
    //   disabled: ctx.disabledFieldList.includes('generateSalesDepartmentName'),
    //   // disabled: ctx.isDisabledGenerateSalesCompanyNo,
    // },
    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司',
    //   type: 'select',
    //   options: ctx.recyclingCompanyFileList || [],
    //   changeMethod: 'changeMethod',
    //   isHidden: ctx.hiddenList.includes('recyclingCompanyFileNo'),
    //   disabled: ctx.disabledFieldList.includes('recyclingCompanyFileNo'),
    // },
    // {
    //   prop: 'recyclingCompanyFileNo',
    //   name: '回收公司档案编号',
    //   type: 'input',
    //   disabled: true,
    //   isHidden: ctx.hiddenList.includes('recyclingCompanyFileNo'),
    // },
    // {
    //   prop: 'platformCompanyFileNo',
    //   name: '平台公司',
    //   type: 'select',
    //   options: ctx.platformCompanyFileList || [],
    //   isHidden: ctx.hiddenList.includes('platformCompanyFileNo'),
    //   disabled: ctx.disabledFieldList.includes('platformCompanyFileNo'),
    //   changeMethod: 'changeMethod',
    // },
    // {
    //   prop: 'platformCompanyFileNo',
    //   name: '平台公司档案编号',
    //   type: 'input',
    //   disabled: true,
    //   isHidden: ctx.hiddenList.includes('platformCompanyFileNo'),
    // },

    {
      prop: 'mark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 512,
      disabled: ctx.disabledFieldList.includes('mark'),
    },
  ];
};

export const formRule = (ctx) => {
  // let projectRequired = true;
  // if (COMPANY_CODE1.includes(ctx.baseFormData.companyCode)) {
  //   projectRequired = false;
  // }

  // if (ctx.baseFormData.isRelatedParty == 'Y') {
  //   projectRequired = false;
  // }

  return {
    // projectInitiationNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    supplierNo: [{ required: true, message: '必填字段', trigger: 'change' }],
    companyCode: [{ required: true, message: '必填字段', trigger: 'change' }],
    companyCurrency: [{ required: true, message: '必填字段', trigger: 'change' }],
    // customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
    departmentCode: [{ required: true, message: '必填字段', trigger: 'change' }],
    contractSalesmanNo: [{ required: true, message: '业务员必填', trigger: ['change', 'blur'] }],
    // projectName: [
    //   {
    //     required: projectRequired,
    //     message: '必填字段',
    //     trigger: ['blur', 'change'],
    //   },
    // ],
    contractName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    // recyclingCompanyFileNo: [{ required: true, message: '必填字段', trigger: ['change'] }],
    // recyclingCompanyName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    // platformCompanyFileNo: [{ required: true, message: '必填字段', trigger: 'blur' }],
    // platformCompanyName: [{ required: true, message: '必填字段', trigger: 'blur' }],
    // generateSalesCompanyName: [{ required: true, message: '必填字段', trigger: 'change' }],
    // generateSalesDepartmentName: [{ required: true, message: '必填字段', trigger: 'change' }],
    isRestrict: [{ required: true, message: '必填字段', trigger: 'change' }],
    pricingRule: [
      {
        required: ctx.baseFormData.isFixedPrice ? true : false,
        message: '必填字段',
        trigger: 'change',
      },
    ],
    contractTotalAmount: [
      // 除了协议别的必须
      {
        required: ctx.$route.query.type != 'CG02',
        message: '必填字段',
        trigger: ['blur', 'change'],
      },
    ],
    creditAmount: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    overShippedPercentage: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    shortShippedPercentage: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    performanceBond: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    liquidatedInterestRate: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    creditPercent: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    liquidatedFixedValue: [{ validator: isNumberValidator, trigger: ['blur', 'change'] }],
    contractValidEnd: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.companyCode) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
      { validator: validatorContractValidEnd(ctx), trigger: ['blur', 'change'] },
    ],
    contractValidStart: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.companyCode) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
      { validator: validatorContractValidStart(ctx), trigger: ['blur', 'change'] },
    ],
    signDate: [
      {
        required: COMPANY_CODE1.includes(ctx.baseFormData.companyCode) ? true : false, // 只要城矿公司需要校验
        message: '必填字段',
        trigger: 'blur',
      },
      { validator: validatorSignDate(ctx), trigger: ['blur', 'change'] },
    ],
  };
};

// 合同到期日 contractValidEnd
// 合同生效日期 contractValidStart
// 合同签署日期  signDate
// 合同到期日期>合同生效日期>=合同签署日期
const validatorContractValidEnd = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseFormData.contractValidStart && value <= ctx.baseFormData.contractValidStart) {
        callback(new Error('合同到期日必须大于合同生效日期!'));
      }
      if (ctx.baseFormData.signDate && value < ctx.baseFormData.signDate) {
        callback(new Error('合同到期日必须大于合同签署日'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};
const validatorContractValidStart = (ctx) => {
  return (_, value, callback) => {
    console.log(value, ctx.baseFormData.contractValidEnd, '第二个时间');
    if (value) {
      if (ctx.baseFormData.contractValidEnd && value > ctx.baseFormData.contractValidEnd) {
        callback(new Error('合同生效日期必须小于合同到期日期!'));
      }
      if (ctx.baseFormData.signDate && value < ctx.baseFormData.signDate) {
        callback(new Error('合同生效日必须大于合同签署日期!'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};
const validatorSignDate = (ctx) => {
  return (_, value, callback) => {
    if (value) {
      if (ctx.baseFormData.contractValidStart && value > ctx.baseFormData.contractValidStart) {
        callback(new Error('合同签署日期必须小于合同生效日期'));
      }
      return callback();
    } else {
      return callback();
    }
  };
};
